export default "/_next/static/images/Esport-9e66cff30aca73a279a236a3018de2e8.png";